import { Outlet } from "react-router";
import {
  Building2,
  GitBranch,

  Users,
  Shield,
  Blocks,
  Hash,
  Printer,
  Mail,
  Settings,
  CreditCard,
  History,
  DatabaseBackup,
  Share2,
  Upload,
  Clock,
  Puzzle,
  Link2,
  Globe,
  BarChart3,
  Zap,
  Landmark,
  FileText,
} from "lucide-react";
import { SidebarProvider, SidebarInset, SidebarTrigger } from "@kubdee/ui/shadcn/sidebar";
import { AppSidebar, type NavGroup } from "@kubdee/ui/shell/app-sidebar";
import { MODULES } from "@kubdee/shared/module-ids";

const settingsNav: NavGroup[] = [
  {
    label: "ทั่วไป",
    items: [
      { title: "ภาพรวม", href: "/settings/dashboard", icon: Settings },
    ],
  },
  {
    label: "องค์กร",
    items: [
      { title: "บริษัท", href: "/settings/company", icon: Building2 },
      { title: "ตั้งค่าบัญชี", href: "/settings/company/accounting", icon: Landmark },
      { title: "สาขา", href: "/settings/branches", icon: GitBranch },
      { title: "ช่องทางลูกค้า", href: "/settings/channels", icon: Share2 },
    ],
  },
  {
    label: "ผู้ใช้งาน",
    items: [
      { title: "ผู้ใช้", href: "/settings/users", icon: Users },
      { title: "บทบาทและสิทธิ์", href: "/settings/roles", icon: Shield },
    ],
  },
  {
    label: "ระบบ",
    items: [
      { title: "โมดูล", href: "/settings/modules", icon: Blocks },
      { title: "Doctypes", href: "/settings/doctypes", icon: FileText },
      { title: "เลขที่เอกสาร", href: "/settings/numbering", icon: Hash },
      { title: "Print Templates", href: "/settings/print-templates", icon: Printer },
      { title: "อีเมล", href: "/settings/email", icon: Mail },
      { title: "Custom Fields", href: "/settings/custom-fields", icon: Puzzle },
      { title: "งานตั้งเวลา", href: "/settings/jobs", icon: Clock },
      { title: "Webhooks", href: "/settings/webhooks", icon: Link2 },
      { title: "Portal", href: "/settings/portal", icon: Globe },
      { title: "กฎอัตโนมัติ", href: "/settings/automation", icon: Zap },
      { title: "รายงาน", href: "/settings/reports", icon: BarChart3 },
    ],
  },
  {
    label: "การเงิน",
    items: [
      { title: "การเงิน", href: "/settings/billing", icon: CreditCard },
      { title: "ประวัติการชำระ", href: "/settings/billing/history", icon: History },
    ],
  },
  {
    label: "ข้อมูล",
    items: [
      { title: "นำเข้าข้อมูล", href: "/settings/data/import", icon: Upload },
      { title: "ส่งออก / ลบข้อมูล", href: "/settings/data/export", icon: DatabaseBackup },
    ],
  },
];

export default function SettingsLayout({
  children,
}: {
  children?: React.ReactNode;
}) {
  return (
    <SidebarProvider>
      <AppSidebar moduleId={MODULES.CORE} title="Settings" navGroups={settingsNav} />
      <SidebarInset className="flex flex-col h-svh">
        {children ?? <Outlet />}
      </SidebarInset>
    </SidebarProvider>
  );
}
